var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCogSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2804 24.8527C42.5034 24.8248 42.7083 24.7161 42.8563 24.5471C43.0044 24.3781 43.0852 24.1606 43.0834 23.936V20.0603C43.0852 19.8357 43.0044 19.6182 42.8563 19.4492C42.7083 19.2802 42.5034 19.1715 42.2804 19.1437L38.1536 18.6285C37.7329 16.6072 36.9336 14.6838 35.7978 12.9598L38.3553 9.65982C38.4922 9.48356 38.5601 9.26339 38.5463 9.04062C38.5324 8.81785 38.4378 8.60778 38.2801 8.44982L35.5301 5.69982C35.3721 5.54212 35.1621 5.44748 34.9393 5.43364C34.7165 5.4198 34.4964 5.48772 34.3201 5.62465L31.0348 8.20415C29.3104 7.06849 27.3872 6.2686 25.3661 5.84648L24.8509 1.72148C24.8231 1.49856 24.7143 1.29363 24.5454 1.1456C24.3764 0.997573 24.1589 0.916751 23.9343 0.918484H20.0586C19.834 0.916751 19.6165 0.997573 19.4475 1.1456C19.2785 1.29363 19.1698 1.49856 19.1419 1.72148L18.6268 5.84648C16.6082 6.26947 14.6875 7.06934 12.9654 8.20415L9.6746 5.64665C9.49834 5.50972 9.27818 5.4418 9.0554 5.45564C8.83263 5.46948 8.62256 5.56412 8.4646 5.72182L5.7146 8.47182C5.55691 8.62978 5.46227 8.83985 5.44843 9.06262C5.43459 9.28539 5.50251 9.50556 5.63944 9.68182L8.2061 12.9818C7.07027 14.7058 6.27093 16.6292 5.85027 18.6505L1.72344 19.1657C1.50052 19.1935 1.29559 19.3022 1.14756 19.4712C0.999526 19.6402 0.918704 19.8577 0.920437 20.0823V23.9433C0.918704 24.168 0.999526 24.3854 1.14756 24.5544C1.29559 24.7234 1.50052 24.8321 1.72344 24.86L5.85027 25.3752C6.27093 27.3964 7.07027 29.3198 8.2061 31.0438L5.6486 34.3438C5.51167 34.5201 5.44376 34.7402 5.4576 34.963C5.47143 35.1858 5.56608 35.3959 5.72377 35.5538L8.47377 38.3038C8.63173 38.4615 8.8418 38.5562 9.06457 38.57C9.28734 38.5838 9.50751 38.5159 9.68377 38.379L12.9838 35.8215C14.7081 36.9571 16.6313 37.757 18.6524 38.1792L19.1676 42.3042C19.1955 42.5271 19.3042 42.732 19.4732 42.88C19.6422 43.0281 19.8596 43.1089 20.0843 43.1072H23.9673C24.1919 43.1089 24.4094 43.0281 24.5784 42.88C24.7473 42.732 24.8561 42.5271 24.8839 42.3042L25.3991 38.1792C27.4202 37.757 29.3434 36.9571 31.0678 35.8215L34.3586 38.379C34.5349 38.5159 34.755 38.5838 34.9778 38.57C35.2006 38.5562 35.4106 38.4615 35.5686 38.3038L38.3186 35.5538C38.4763 35.3959 38.5709 35.1858 38.5848 34.963C38.5986 34.7402 38.5307 34.5201 38.3938 34.3438L35.8363 31.0438C36.9721 29.3198 37.7714 27.3964 38.1921 25.3752L42.2804 24.8527Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 33.9185C28.5816 33.9185 33.9168 28.5833 33.9168 22.0019C33.9168 15.4205 28.5816 10.0852 22.0002 10.0852C15.4188 10.0852 10.0835 15.4205 10.0835 22.0019C10.0835 28.5833 15.4188 33.9185 22.0002 33.9185Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10.0852V19.2519",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 24.752C23.5188 24.752 24.75 23.5207 24.75 22.002C24.75 20.4832 23.5188 19.252 22 19.252C20.4812 19.252 19.25 20.4832 19.25 22.002C19.25 23.5207 20.4812 24.752 22 24.752Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1636 23.7014L31.3704 29.3646",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8367 23.7014L12.6299 29.3646",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCogSettings);
export default __webpack_public_path__ + "static/media/cog_settings.ae1ad6957dcefdc019ea24420787f8b7.svg";
export { ForwardRef as ReactComponent };